import { createContext } from "react";
import { NORTH_AMERICA, type UserAudienceInfo } from "@repo/utils";
import { type AudienceContextType, createAudiencePaths } from "./audience";

const defaultAudienceInfo: UserAudienceInfo = {
  audience: NORTH_AMERICA,
  country: "us",
  lang: "en",
};

const defaultAudienceContext: AudienceContextType = {
  ...defaultAudienceInfo,
  paths: createAudiencePaths(defaultAudienceInfo),
};

/**
 * AudienceContext provides the user's audience information and audience-specific paths throughout the application.
 * @returns {AudienceContextType} The context containing audience info and paths.
 */
export const AudienceContext = createContext<AudienceContextType>(
  defaultAudienceContext,
);
